import createTableStore from "ds/components/Table/store/useTableStore";

import {
  POLICY_TEMPLATES_TABLE_COLUMNS_CONFIG,
  POLICY_TEMPLATES_TABLE_STORAGE_KEY,
} from "./constants";

const usePolicyTemplatesTableStore = createTableStore({
  storageKey: POLICY_TEMPLATES_TABLE_STORAGE_KEY,
  config: POLICY_TEMPLATES_TABLE_COLUMNS_CONFIG,
});

export default usePolicyTemplatesTableStore;
